type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

/** Lead classification → badge tone. Unknown values fall back to neutral. */
export function leadTypeTone(type: string): BadgeTone {
  switch (type) {
    case 'lead':
    case 'white':
      return 'success'
    case 'black':
      return 'info'
    case 'bot':
      return 'warning'
    case 'abuse':
      return 'danger'
    default:
      return 'neutral'
  }
}
